import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=026a1d20&scoped=true"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"
import style0 from "./VDropdown.vue?vue&type=style&index=0&id=026a1d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a1d20",
  null
  
)

export default component.exports